import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { Layout, Typography, Space } from 'antd';

import { Exchanges, Homepage, News, Cryptocurrencies, CryptoDetails, Navbar } from './components';
import './App.css';


const App = () => (
  <div className="app">
    <div className="navbar">
      <Navbar />
    </div>
    <div className="main">
      <Layout>
        <div className="routes">
          <Switch>
            <Route exact path="/">
              <Homepage />
            </Route>
            <Route exact path="/cryptocurrencies">
              <Cryptocurrencies />
            </Route>
            <Route exact path="/crypto/:coinId">
              <CryptoDetails />
            </Route>
            <Route exact path="/news">
              <News />
            </Route>
          </Switch>
        </div>
      </Layout>
      <div className="footer">
      <Typography.Title level={5} style={{ color: 'white', textAlign: 'center' }}>
        Crashers <br />
        By <a href="https://www.linkedin.com/in/tutu-mtetwa/" target="_blank" rel="noopener noreferrer">Tutu</a> & <a href="https://www.linkedin.com/in/tatendanyoni/" target="_blank" rel="noopener noreferrer">Tate</a> <br />
        © 2024 All Rights Reserved.
      </Typography.Title>

        <Space>
          <Link to="/">Home</Link>
          <Link to="/news">News</Link>
        </Space>
      </div>
    </div>
  </div>
);

export default App;